export default __webpack_public_path__ + "static/media/ejsorg.464893d7.png";